<script>
import Header from "@/components/Header.vue";
import {ListLogicMixin} from '@/assets/js/mixins/list-logic-mixin';
import axios from "axios"
import _ from "lodash";
import IpImport from "@/components/modal/IpImport.vue";
import IpEdit from "@/components/modal/IpEdit.vue";
import SelectSearch from "@/components/filters/SelectSearch.vue";
import {EventBus} from "@/eventBus";

export default {
  name: "IpList",
  components: {SelectSearch, IpEdit, IpImport, Header},
  mixins: [
    ListLogicMixin
  ],
  data: () => {
    return {
      apiList: '/api/manager/ip/list',
      apiUrl: '/api/manager/ip/',
      apiMultyDelete: '/api/manager/ip/delete',
      filterOptions: {
        'State': {
          'options': [],
          'uri': '/api/manager/ip/flat?group=State',
          'labelField': 'State',
          'valueField': 'State'
        },
        'Datacenter': {'options': [], 'uri': '/api/manager/dc/flat?sort=Ip', 'labelField': 'Name', 'valueField': 'Id'},
        'linkedServerEntity': {
          'options': [
            {
              "value": "",
              "label": "ANY"
            },
            {
              "value": "n/a",
              "label": "N/A"
            },
            {
              "value": "none",
              "label": "none"
            },
            {
              "value": "esxi",
              "label": "ESXi"
            },
            {
              "value": "baremetal",
              "label": "Baremetal"
            },
            {
              "value": "proxmox",
              "label": "Proxmox"
            }
          ]
        },
        'linkedServer': {
          'options': [],
          'uri': '/api/manager/server/flat?sort=Id',
          'labelField':  'Name',
          'valueField': 'Id',
          'valueType': 'Number'
        },
        'UsedBy': {
          'options': [
            {
              "value": "",
              "label": "ANY"
            },
            {
              "value": "none",
              "label": "None"
            }, {
              "value": "vm",
              "label": "VM"
            },
            {
              "value": "esxi",
              "label": "ESXi"
            },
            {
              "value": "baremetal",
              "label": "Baremetal"
            },
            {
              "value": "ipmi",
              "label": "IPMI"
            },
            {
              "value": "vps",
              "label": "VPS"
            },
            {
              "value": "proxmox",
              "label": "Proxmox"
            }
          ]
        }
        ,
      },
      emptyFieldValue: {
        "value": "",
        "label": "ANY"
      },
      pageTitle: 'IPs',
      pageFilter: '',
      pageTotal: '',
      total: 0,
      title: 'IPs',
      allSelected: false,
      filterExact: ["LinkedServerEntityId", "DcId"],
      items: [],
      queryFilter: [],
      options: [],
      currentItem: {},
      itemsSelectedCount: 0,
      filterValues: {
        'DcId': 0,
        'UsedBy': "",
        'LinkedServerEntity': "",
        'State': "",
      },
      limit: "100",
      selectValues: {
        "State":"",
        "DcId":"",
        "ServerId":"",
        "UsedBy":"",
        "LinkedServerEntity":"",
      },
    }
  },
  methods: {
    filterChanged() {
      this.filterSend()
    },
    filterSend() {
      let currentQuery = this.$route.query;
      let newFilters = [];
      for (let FieldName in this.filterValues) {
        if (this.filterValues[FieldName] !== '') {
          if (FieldName === 'DcId') {
            if (this.filterValues[FieldName] === 0 || this.filterValues[FieldName] === "" || this.filterValues[FieldName] == null) {
              continue;
            }
          }
          let data = {};
          data[FieldName] = this.filterValues[FieldName];
          if (data[FieldName] !== null) {
            if (this.filterExact.includes(FieldName)) {
              newFilters.push({
                Condition: "=",
                Data: data,
              });
            } else {
              newFilters.push({
                Condition: "ilike",
                Data: data,
              });
            }
          }
        }
      }
      if (JSON.stringify(currentQuery) !== JSON.stringify({filter: JSON.stringify(newFilters)})) {
        this.$router.push({query: {filter: JSON.stringify(newFilters)}});
        this.filters = newFilters;
        this.queryFilter = newFilters;
        this.LoadData()
      } else {
        console.log('Filter error: filter duplicate')
      }
    },
    BeforeLoadData() {
      _.map(this.filters, (filter, index) => {
        if (filter.Data?.UsedBy) {
          this.filters[index] = {
            "Condition": "=",
            "Data": {"UsedByEntityOrVm": `${filter.Data.UsedBy}`}
          }
        }
      })
    },
    changeFilterValue(event, filter) {
      this.filterValues[filter] = event === null ? "" : event
      this.filterSend()
      if (this.selectValues[filter] !== undefined && this.selectValues[filter] !== null) {
        this.selectValues[filter] = event;
      }
    },
    editItem(item) {
      this.currentItemId = parseInt(item.Id);
      this.$modal.show('IpEdit');
    },
    loadOptions: async function () {
      await _.forOwn(this.filterOptions, (value, key) => {
        if (value.uri && key !== 'UsedBy') {
          this.filterOptions[key].options = this.getOptions(value.labelField, value.valueField, value.uri, key, this.filterOptions[key].options)
          this.filterOptions[key].options.push(this.emptyFieldValue);
        }
      })
      this.filterPreparing();
      this.filterQuery();
      this.setFilterValuesFromRoute();
      this.LoadData();
    },
    getOptions: function (labelField, valueField, query, key, currentOptions = []) {
      const options = currentOptions
      axios.post(query, [], this.authRespConf())
          .then(res => {
            if (res === undefined || res === null) {
              return []
            }
            if (res.data.data !== undefined) {
              for (let dataIndex in res.data.data) {
                options.push({
                  value: res.data.data[dataIndex][valueField],
                  label: key.toLowerCase() === 'state' ? this.getStateOptionLabel(res.data.data[dataIndex][labelField]) : res.data.data[dataIndex][labelField],
                });
              }
            }
          });
      return options;
    },
    selectAll: function () {
      this.selectedItemsList = [];
      this.itemsSelectedCount = 0
      if (this.allSelected) {
        let index;
        for (index in this.items) {
          this.selectedItemsList.push(this.items[index].Id);
          this.itemsSelectedCount++
        }
      }
    },
    clearFilter() {
      for (let FieldName in this.filterValues) {
        this.filterValues[FieldName] = '';
      }
      for (let FieldName in this.selectValues) {
        this.selectValues[FieldName] = '';
      }
      this.filters = [];
      this.queryFilter = [];
      this.$route.query.filter;
      this.filterChanged();
    },
    actionDelete() {
      this.confirmModalTitle = 'Confirm delete IPs';
      this.confirmModalMsg =
          'Are you sure you want to delete ' +
          document.getElementsByClassName('selected').length +
          ' IPs?';
      this.$modal.show('confirm');
    },
    addIp() {
      this.$modal.show('IpImport')
    },
    modalsHide() {
      this.$modal.hide('IpEdit');
      this.$modal.hide('IpImport');
      this.$modal.hide('confirmItemDelete');
      this.$modal.hide('confirm');
    },
  },
  computed: {
    EventBus() {
      return EventBus
    },
    datacenterValue() {
      let founded = _.find(this.filterOptions.Datacenter.options, {value: this.filterValues['DcId']})
      if (!founded) {
        founded = ""
      }
      return founded
    },
    usedByValue() {
      let founded = _.find(this.filterOptions.UsedBy.options, {value: this.filterValues['UsedBy']})
      if (!founded) {
        founded = ""
      }
      return founded
    },
    linkedServerEntityValue() {
      let founded = _.find(this.filterOptions.linkedServerEntity.options, {value: this.filterValues['LinkedServerEntity']})
      if (!founded) {
        founded = ""
      }
      return founded
    },
    linkedServerValue() {
      let founded = _.find(this.filterOptions.linkedServer.options, {value: this.filterValues['LinkedServer']})
      if (!founded) {
        founded = ""
      }
      return founded
    },
  },
  watch: {
    '$route': function (val) {
      console.log('ip watch $route', val);
      this.setTitleByFilters();
    },
    selectedItemsList(val) {
      this.itemsSelectedCount = val.length
      if (this.itemsSelectedCount === 0) {
        this.allSelected = false
      }
    },
    filterValues: {
      handler: function () {
        this.setTitleByFilters();
      },
      deep: true
    },
    queryFilter: function () {
      this.setTitleByFilters();
    },
    // queryFilter: function (val) {
    //   const $this = this
    //   if (!_.isEqual(val, this.newFilters)) {
    //     let unnamedFilter = ""
    //     _.forEach(val, function (field) {
    //       unnamedFilter = unnamedFilter += $this.getUnnamedFilter(field)
    //     })
    //     if (unnamedFilter !== "") {
    //       $this.pageTitle = 'IPs for: ' + unnamedFilter
    //     } else {
    //       $this.pageTitle = 'IPs'
    //     }
    //   }
    // },
  },

  created() {
    this.loadOptions()
    EventBus.$on("ip-update", this.handleUpdate);
    EventBus.$on("ip-rq", this.handleUpdate);
    EventBus.$on("ip-add", this.handleAdd);
    EventBus.$on("ip-delete", this.handleDelete);
    EventBus.$on("ip-del", this.handleDelete);
    EventBus.$on("EscapeKeyDown", this.modalsHide);
    this.setFilterValuesFromRoute();
  },
  beforeDestroy() {
    EventBus.$off("ip-update", this.handleUpdate);
    EventBus.$off("ip-rq", this.handleUpdate);
    EventBus.$off("ip-add", this.handleAdd);
    EventBus.$off("ip-delete", this.handleDelete);
    EventBus.$off("ip-del", this.handleDelete);
    EventBus.$off("EscapeKeyDown", this.modalsHide);
  },
}
</script>

<template>
  <!--  <list-page create-title="New IPs" update-title="Edit IP: " updateTitleKey="Address"  :modalHeightEdit="720" :modalHeightCreate="270"/>-->
  <div class="page">
    <Header
        :title=pageTitle
        :filter=pageFilter
        :total=pageTotal
    />
    <div v-show="isDataVisible" class="container dashboard card">
      <div class="card-header">
        <span class="other-buttons">
          <button @click="downloadTable()" class="btn btn-primary">
            <i class="fa fa-download"></i>
          </button>
        </span>
        <span class="other-buttons">
          <a
              target="_blank"
              v-on:click.prevent.stop="EventBus.$emit('openSidebar', '#/ip/import');"
              href="#/ip/import">
            <button class="btn btn-primary">Add/Update IPs</button>
          </a>
        </span>
        <span class="special-buttons" v-tippy="{arrow : true, onShow: () => itemsSelectedCount === 0 }"
              title="Please select IPs to delete">
        <button class="btn btn-default delete-btn small icon-only"
                @click="actionDelete()"
                :class="['btn btn-danger', { 'disabled': itemsSelectedCount === 0 }]">
          Delete <span v-if="itemsSelectedCount <= 1">IP</span><span v-else>IPs</span>  <i class="fa fa-trash"></i>
        </button>
        </span>
      </div>
      <div class="card-body">
        <div class="alert alert-info alert-dismissable" v-show="info !== ''">
          <strong>
            <b-icon icon="info-circle-fill"></b-icon>
          </strong>
          <div class="alert-text" style="display: inline-block;"> {{ info }}</div>
        </div>
        <div v-bind:class="loading"></div>
        <table class="table table-responsive-sm" id="resizable-table">
          <thead>
          <tr>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Id')">ID</span>
              <span class="icon-up" v-show="sortField === '-Id'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Id'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th style="width: 7rem;">
              <span class="col-text cursor-pointer" @click="SortInvert('State')">State 🚦</span>
              <span class="icon-up" v-show="sortField === '-State'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'State'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Address')">IP ɪᴘ</span>
              <span class="icon-up" v-show="sortField === '-Address'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Address'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Gateway')">Gateway 🔁</span>
              <span class="icon-up" v-show="sortField === '-Gateway'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Gateway'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('Mac')">MAC</span>
              <span class="icon-up" v-show="sortField === '-Mac'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'Mac'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('DcName')">Datacenter 🌐</span>
              <span class="icon-up" v-show="sortField === '-DcName'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'DcName'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('ServerTypeJoined')">Used By</span>
              <span class="icon-up" v-show="sortField === '-ServerTypeJoined'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'ServerTypeJoined'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th>
              <span class="col-text cursor-pointer" @click="SortInvert('LinkedServerEntity')">Linked to ⛓</span>
              <span class="icon-up" v-show="sortField === '-LinkedServerEntity'"><b-icon icon="arrow-up"></b-icon></span>
              <span class="icon-up" v-show="sortField === 'LinkedServerEntity'"><b-icon icon="arrow-down"></b-icon></span>
            </th>
            <th/>
            <th scope="col" class="text-center">
              <b-checkbox
                  @change="selectAll()"
                  v-model="allSelected"
              ></b-checkbox>
            </th>
          </tr>
          <tr @keyup.enter="filterChanged">
            <th/>
            <th>
              <b-form-select
                  :options="filterOptions.State.options"
                  text-field="label"
                  value-field="value"
                  @change="changeFilterValue($event, 'State')"
                  v-model="selectValues['State']"
                  placeholder="ANY"
                  inputId="state"
                  clearable/>
            </th>
            <th>
              <b-input-group>
                <b-form-input v-model="filterValues['Address']" placeholder="IP"></b-form-input>
                <b-input-group-append is-text>
                  <input type="checkbox" v-model="filterExact" value="Address" content="Exact phrase"
                         v-tippy="{arrow : true}" aria-label="Exact phrase">
                </b-input-group-append>
              </b-input-group>
            </th>
            <th>
              <b-input-group>
                <b-form-input v-model="filterValues['Gateway']" placeholder="Gateway"></b-form-input>
                <b-input-group-append is-text>
                  <input type="checkbox" v-model="filterExact" value="Gateway" content="Exact phrase"
                         v-tippy="{arrow : true}" aria-label="Exact phrase">
                </b-input-group-append>
              </b-input-group>
            </th>
            <th>
              <b-input-group>
                <b-form-input v-model="filterValues['Mac']" placeholder="Mac"></b-form-input>
                <b-input-group-append is-text>
                  <input type="checkbox" v-model="filterExact" value="Mac" content="Exact phrase"
                         v-tippy="{arrow : true}" aria-label="Exact phrase">
                </b-input-group-append>
              </b-input-group>
            </th>
            <th>
              <b-form-select
                  :options="filterOptions.Datacenter.options"
                  text-field="label"
                  value-field="value"
                  @change="changeFilterValue($event, 'DcId')"
                  v-model="selectValues['DcId']"
                  placeholder="ANY"
                  inputId="dcName"
                  id="DcId"
                  clearable/>
              <SelectSearch :handler-func="changeFilterValue" field="DcId" :options=filterOptions.Datacenter.options></SelectSearch>
            </th>
            <th>
              <b-form-select
                  :options="filterOptions.UsedBy.options"
                  text-field="label"
                  value-field="value"
                  @change="changeFilterValue($event, 'UsedBy')"
                  v-model="selectValues['UsedBy']"
                  placeholder="ANY"
                  inputId="UsedBy"
                  id="UsedBy"
                  clearable/>
            </th>
            <th>
              <div class="half-filter-select">
                <b-form-select
                    :options="filterOptions.linkedServerEntity.options"
                    text-field="label"
                    value-field="value"
                    @change="changeFilterValue($event, 'LinkedServerEntity')"
                    v-model="selectValues['LinkedServerEntity']"
                    placeholder="ANY"
                    inputId="LinkedServerEntity"
                    id="LinkedServerEntity"
                    clearable/>
              </div>
              <div class="half-filter-select">
                <b-form-select
                    :options="filterOptions.linkedServer.options"
                    text-field="label"
                    value-field="value"
                    @change="changeFilterValue($event, 'ServerId')"
                    v-model="selectValues['ServerId']"
                    placeholder="ANY"
                    inputId="ServerId"
                    id="ServerId"
                    clearable/>
                <SelectSearch :handler-func="changeFilterValue" field="ServerId" :options=filterOptions.linkedServer.options></SelectSearch>
              </div>
            </th>
            <th>
            <span class="cel-buttons">
              <span class="icon-search" @click="filterChanged()" title="Apply filters"><i
                  class="fa fa-solid fa-search"></i></span>
               <span class="icon-clear" @click="clearFilter()" title="Clear filters">
                <font-awesome-icon icon="recycle" class="icon alt"/>
               </span>
            </span>
            </th>
            <th/>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="item in items"
              v-bind:key="item.id"
              @click="rowClick(item, $event)"
              :data-item-id="item.Id"
              :id="'item' + item.Id"
              :class="{'selected':selectedItemsList.indexOf(item.Id) >= 0}"
          >
            <td>
              <span class="cel-text">{{ item.Id }}</span>
            </td>
            <td>
              <span v-tippy="{arrow : true}" :content="'state: ' + item.State + ' Discovered At: ' + item.DiscoveredAt">
                 <span v-if="item.State === 'OK'" style="all: initial;">🟢</span>
                <span v-else-if="item.State === 'NO PING'" style="all: initial;">🔴</span>
                <span v-else-if="item.State === '' || item.State === null" style="all: initial;">0️⃣️</span>
              </span>
            </td>
            <td>
              <span class="cel-text copy-click" @click="(event) => copyText(item.Address, event)">
                <span class="text-for-copy">{{ item.Address }}</span>
                <i class="fa fa-copy"></i><i class="fa fa-check"></i><i class="fa fa-ban"></i>
              </span>
            </td>
            <td>
              <span class="cel-text">{{ item.Gateway }}</span>
            </td>
            <td>
              <span class="cel-text">{{ item.Mac }}</span>
            </td>
            <td>
              <span class="cel-text">
                <a :href='`/?#/server/list?page=1&filter=[{\"Condition\":\"=\",\"Data\":{\"DcId\":\"${item.DcId}\"}}]`'>
                     {{ item.DcName }}
                </a>
              </span>
            </td>
            <td>
              <span class="cel-text">
                <span v-if="item.UsedByEntityOrVm !== 'none'">{{ item.UsedByEntityOrVm }} [<a
                    :href='`/?#/server/list?page=1&filter=[{\"Condition\":\"=\",\"Data\":{\"Name\":\"${item.UsedByName}\"}}]`'>{{
                    item.UsedByName
                  }}</a>]</span>
                <span v-else>{{ item.UsedByEntityOrVm }}</span>
              </span>
            </td>
            <td>
              <span class="cel-text">
                <span
                    v-if="item.LinkedServerEntity === 'esxi' && item.LinkedServerName && (item.LinkedServerAddress !== 'none' && item.LinkedServerAddress !== 'N/A')">
                  <span class='esxi-field'>[<a :href='`https://${item.LinkedServerAddress}`'
                                               target="_blank">{{ item.LinkedServerAddress }}</a>] <a
                      :href='`/?#/server/list?page=1&filter=[{\"Condition\":\"=\",\"Data\":{\"Id\":${item.ServerId}}}]`'>{{
                      item.LinkedServerName
                    }}</a></span>
                </span>
                <span
                    v-else-if="item.LinkedServerName && (item.LinkedServerAddress !== 'none' && item.LinkedServerAddress !== 'N/A')"><span
                    class='esxi-field'> [<a
                    :href='`https://${item.LinkedServerAddress}`' target="_blank">{{ item.LinkedServerAddress }}</a>] <a
                    :href='`/?#/vm/list?page=1&filter=[{\"Condition\":\"=\",\"Data\":{\"Id\":${item.LinkedServerEntityId}}}]`'>{{
                    item.LinkedServerName
                  }}</a></span>
                </span>
                <span v-else-if="item.LinkedServerAddress !== 'none' && item.LinkedServerAddress !== 'N/A'">[<a
                    :href='`https://${item.LinkedServerAddress}`' target="_blank">{{
                    item.LinkedServerAddress
                  }}</a>]</span>
                <span v-else>{{ item.LinkedServerAddress }}</span>
              </span>
            </td>
            <td>
              <span class="cel-buttons">
                <button class="btn btn-as-link icon-only" @click="editItem(item)"><i class="fa fa-pencil"></i></button>
                <button class="btn btn-as-link icon-only  text-danger" @click="openDeleteItemConfirmation(item)"><i
                    class="fa fa-trash"></i></button>
              </span>
            </td>
            <td class="text-center">
              <b-checkbox
                  v-model="selectedItemsList"
                  :value="item.Id"
              ></b-checkbox>
            </td>
          </tr>
          </tbody>
        </table>
        <p class="text-center" v-if="items?.length === 0">Nothing found</p>
        <ListControls
            v-else
            v-on:onLimitChanged="ChangeLimit"
            :total="total"
            :default-limit="limit"
            :options="[
                {value: '10',text: '10'},
                {value: '50',text: '50'},
                {value: '100',text: '100'},
                {value: '500',text: '500'},
                {value: '1000',text: '1000'},
            ]"
        />
      </div>
    </div>
    <IpEdit :itemId="currentItemId"/>
    <IpImport/>
    <ModalError name="listError" :message="error"/>
    <ModalSuccess name="listSuccess" :message="success"/>
    <ModalConfirmItemDelete
        v-on:onComplete="deletedItem"
        v-on:onError="deletedItemErr"
        :title="confirmModalTitle"
        :url="apiUrl"
        :itemId="currentItemId"
    />
    <ModalConfirm
        :msg="confirmModalMsg"
        :title="confirmModalTitle"
        v-on:onModalСonfirmEvent="modalConfirmEvent"/>
  </div>
</template>

<style scoped>

</style>